/**
 * Main Entry Point
 *
 * Initializes the React application with:
 * - React Router v7
 * - tRPC Provider
 * - Global styles (Tailwind CSS 4)
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import { AppRouter } from './router'
import { TRPCProvider } from './lib/trpc/Provider'
import './styles/globals.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <TRPCProvider>
      <AppRouter />
    </TRPCProvider>
  </React.StrictMode>
)
